export function getApiBaseUrl() {
  if (window.location.hostname.includes("bharatdhara.com")) {
    return "https://backend.bharatdhara.com/api/";
  }

  return "http://localhost:8001/api/"; // development API
}
